// Add your JS customizations here
// Homepage Slider
// import Swiper JS
import Swiper, { Navigation, EffectFade, Thumbs, HashNavigation } from "swiper";

Swiper.use([Navigation, EffectFade, Thumbs, HashNavigation]);

const funFactSliders = document.getElementsByClassName("fun-fact-slider");
for (let i = 0; i < funFactSliders.length; i++) {
	let newSwiper = new Swiper(funFactSliders[i], {
		navigation: {
			nextEl: funFactSliders[i].parentElement.querySelector(
				".swiper-button-next"
			),
			prevEl: funFactSliders[i].parentElement.querySelector(
				".swiper-button-prev"
			),
		},
		spaceBetween: 40,
		slidesPerView: 1,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			992: {
				slidesPerView: 3,
			},
		},
	});
}

const cardSliders = document.getElementsByClassName("flip-card-back-slider");
for (let i = 0; i < cardSliders.length; i++) {
	let newSwiper = new Swiper(cardSliders[i], {
		slidesPerView: 1,
		navigation: {
			prevEl: `#swiper-button-prev-card-${i + 1}`,
			nextEl: `#swiper-button-next-card-${i + 1}`,
		},
	});
}

// Flip Card
window.addEventListener("DOMContentLoaded", () => {
	const cards = document.getElementsByClassName("flip-card");

	for (let i = 0; i < cards.length; i++) {
		cards[i].addEventListener("click", (e) => {
			console.log(e.target);
			if (
				!e.target.classList.contains("swiper-button") &&
				!e.target.classList.contains("science-link") &&
				!e.target.classList.contains("bio-link") &&
				!e.target.classList.contains("book-link")
			) {
				e.currentTarget
					.querySelector(".flip-card-inner")
					.classList.toggle("active");
			}
		});
	}
});

// Reveal quiz answer
window.addEventListener("DOMContentLoaded", () => {
	const buttons = document.getElementsByClassName("reveal-answer");
	const quizSection = document.getElementById("quiz-answer");
	const answer = document.querySelector(".answer-wrapper");

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener(
			"click",
			(e) => {
				answer.style.maxHeight = "10000px";
				quizSection.style.paddingBottom = "5rem";
			},
			{ once: true }
		);
	}
});

// Video Sliders
window.addEventListener("DOMContentLoaded", () => {
	const thumbnailVideoSliderEl = document.getElementById(
		"thumbnail-video-slider"
	);
	// Video Gallery
	const mainVideoSliderEl = document.getElementById("main-video-slider");

	console.log(mainVideoSliderEl);
	console.log(thumbnailVideoSliderEl);
	if (thumbnailVideoSliderEl && mainVideoSliderEl) {
		const thumbnailVideoSlider = new Swiper(thumbnailVideoSliderEl, {
			spaceBetween: 10,
			slidesPerView: 1,
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
			},
			navigation: {
				nextEl: ".swiper-button-next-thumbnail",
				prevEl: ".swiper-button-prev-thumbnail",
			},
		});
		const mainVideoSlider = new Swiper(mainVideoSliderEl, {
			spaceBetween: 0,
			slidesPerView: 1,
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			hashNavigation: true,
			navigation: {
				nextEl: ".swiper-button-next-main",
				prevEl: ".swiper-button-prev-main",
			},
			thumbs: {
				swiper: thumbnailVideoSlider,
			},
		});
	}
});
